import { render, staticRenderFns } from "./noticeMsg.vue?vue&type=template&id=68c616ce&scoped=true&"
import script from "./noticeMsg.vue?vue&type=script&lang=js&"
export * from "./noticeMsg.vue?vue&type=script&lang=js&"
import style0 from "./noticeMsg.vue?vue&type=style&index=0&id=68c616ce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c616ce",
  null
  
)

export default component.exports